import { render, staticRenderFns } from "./NsHeaderTop.vue?vue&type=template&id=3c381648&scoped=true&"
import script from "./NsHeaderTop.vue?vue&type=script&lang=js&"
export * from "./NsHeaderTop.vue?vue&type=script&lang=js&"
import style0 from "./NsHeaderTop.vue?vue&type=style&index=0&id=3c381648&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c381648",
  null
  
)

export default component.exports